/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Sessions_LabelInputs */

const en_us2_plan_sessions_label = /** @type {(inputs: Plan_Sessions_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plan workouts`)
};

const pt_br2_plan_sessions_label = /** @type {(inputs: Plan_Sessions_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Treinos do plano`)
};

const es_419_plan_sessions_label = /** @type {(inputs: Plan_Sessions_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entrenamientos del plan`)
};

const pt_pt2_plan_sessions_label = /** @type {(inputs: Plan_Sessions_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Treinos do plano`)
};

const fr_fr2_plan_sessions_label = /** @type {(inputs: Plan_Sessions_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Séances du programme`)
};

const de_de2_plan_sessions_label = /** @type {(inputs: Plan_Sessions_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trainings im Plan`)
};

const it_it2_plan_sessions_label = /** @type {(inputs: Plan_Sessions_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Allenamenti della scheda`)
};

/**
* | output |
* | --- |
* | "Plan workouts" |
*
* @param {Plan_Sessions_LabelInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const plan_sessions_label = /** @type {((inputs?: Plan_Sessions_LabelInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Sessions_LabelInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_plan_sessions_label(inputs)
	if (locale === "es-419") return es_419_plan_sessions_label(inputs)
	if (locale === "pt-PT") return pt_pt2_plan_sessions_label(inputs)
	if (locale === "fr-FR") return fr_fr2_plan_sessions_label(inputs)
	if (locale === "de-DE") return de_de2_plan_sessions_label(inputs)
	if (locale === "it-IT") return it_it2_plan_sessions_label(inputs)
	return en_us2_plan_sessions_label(inputs)
});
export { plan_sessions_label as "plan.sessions_label" }